// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__35j4H","head":"ProcedureTableInfo_head__1vCff"};